import merge from 'lodash/merge';
import baseStyles from '../Base/Base.styles';
import {parseResponsiveProperty} from '@converdy/styles';
import {responsiveTextAlignment} from '../Base/responsiveAlignment';

export default ({
  base,
  linkColor,
  linkHoverColor,
  itemSpacing,
  titleSpacing,
}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '--link-color': linkColor,
      '--link-hover-color': linkHoverColor,
      '--item-spacing': itemSpacing,
      '--title-spacing': titleSpacing,
      '& .text': responsiveTextAlignment(base.alignment),
    },
  };

  merge(jss.root, {
    '& .text': responsiveTextAlignment(base.alignment),
    ...merge(
      parseResponsiveProperty((c) => {
        return c ? {'--item-spacing': `${c}px`} : {};
      }, itemSpacing),
      parseResponsiveProperty((c) => {
        return c ? {'--title-spacing': `${c}px`} : {};
      }, titleSpacing),
    ),
  });

  return jss;
};
